module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-client-transactions"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Payment Methods")]), _c('i', {
    staticClass: "fa fa-plus-circle fa-2x",
    attrs: {
      "slot": "action",
      "data-toggle": "create-payment"
    },
    slot: "action"
  })]), _c('div', {
    staticClass: "tabs-inner-content"
  }, [_c('div', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "is-hidden",
    attrs: {
      "id": "create-payment",
      "data-toggler": "is-hidden"
    }
  }, [_c('p', [_vm._v("Select offline payment provider")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_provider),
      expression: "payment_provider"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.payment_provider = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("offline")]), _c('option', [_vm._v("test-pass")]), _c('option', [_vm._v("test-fail")])]), _c('ActionButton', {
    attrs: {
      "action": _vm.handleCreatePayment
    }
  }, [_vm._v("Create")])], 1), _c('base-list', {
    ref: "loader",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7292ccf3!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ClientPaymentMethods.vue
// module id = 2596
// module chunks = 1